import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';

import iconSpinner from 'icons/spinner.svg';

const styles = ({ palette, spacing }) => ({
  full: {},
  page: {},
  root: {
    '&$full, &$page': {
      '& $svg svg': {
        height: 96,
        width: 96,
      },
      height: 96,
      transform: 'scale(1)',
      width: 96,
    },
    '&$page': {
      margin: [spacing.xl, 'auto'],
    },
    animation: 'load 1.4s linear infinite',
    height: 24,
    overflow: 'hidden',
    width: 24,
  },
  svg: {
    '& circle': {
      fill: 'transparent',
      fillOpacity: 0,
      stroke: palette.icon,
      strokeDasharray: 283,
      strokeDashoffset: 85,
      strokeWidth: 15,
      transformOrigin: '50% 50%',
    },
    '& svg': {
      float: 'left',
      height: 24,
      width: 24,
    },
    display: 'block !important',
    fill: 'transparent', // Support legacy clients with CSS spinner
    float: 'left',
  },
});

const pagesWithLoader = ['mainAppSpinner', 'autoexport', 'qualify'];

const Spinner = ({ classes, loading, name, type }) => {
  const SpinnerElement = type === 'full' || type === 'page' ? 'div' : 'i';
  if (!loading) {
    return null;
  }
  return (
    pagesWithLoader.includes(name) &&
    loading && (
      <SpinnerElement
        className={classnames('spinner', classes.root, {
          [classes.full]: type === 'full',
          [classes.page]: type === 'page',
        })}
        style={{ display: 'block' }}
      >
        <ReactSVG src={iconSpinner} style={{ display: 'none' }} className={classes.svg} />
      </SpinnerElement>
    )
  );
};

Spinner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
};

Spinner.defaultProps = {
  name: 'mainAppSpinner', // 'inline', 'full', or 'page'
  type: 'inline',
};

export default withStyles(styles)(Spinner);
